
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/healthcare/whatsapp",
      function () {
        return require("private-next-pages/industry/healthcare/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/healthcare/whatsapp"])
      });
    }
  